import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import BrandingSettings from './BrandingSettings';
import SmtpSettings from './SmtpSettings';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSettings, FiLayout, FiMail, FiLock } = FiIcons;

const Settings = () => {
  const { hasPermission } = useAuth();
  const [activeTab, setActiveTab] = useState('branding');

  if (!hasPermission('all')) {
    return (
      <div className="text-center py-12">
        <SafeIcon icon={FiLock} className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">Access Restricted</h3>
        <p className="text-gray-600">
          Only administrators can access system settings.
        </p>
      </div>
    );
  }

  const tabs = [
    { id: 'branding', label: 'White Labelling', icon: FiLayout, component: BrandingSettings },
    { id: 'smtp', label: 'SMTP Settings', icon: FiMail, component: SmtpSettings }
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">System Settings</h1>
          <p className="text-gray-600 mt-1">
            Configure application branding and system integrations
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Settings Navigation */}
        <div className="lg:col-span-1">
          <nav className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center space-x-3 px-4 py-3 text-sm font-medium transition-colors border-l-4 ${
                  activeTab === tab.id
                    ? 'bg-blue-50 text-blue-600 border-blue-600'
                    : 'text-gray-600 hover:bg-gray-50 border-transparent'
                }`}
              >
                <SafeIcon icon={tab.icon} className="w-5 h-5" />
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Content Area */}
        <div className="lg:col-span-3">
          {ActiveComponent && (
            <ActiveComponent />
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;